import { onHandleGetTenantId } from "@/commons/RCAttribute.ts";

export const baseUrlApi = `${import.meta.env.VITE_BASE_URL_API}/root/odata/`;
export const baseUrlApiToken = `${import.meta.env.VITE_BASE_URL_API_IDENTITY}/root/`

export const BuildURLWithTenantId = (url: string): string => {
  const tId = onHandleGetTenantId();
  url = url.replace("root", tId || "root");
  return url;
};
